const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

    (binding.modules['sheikhzayedfestival'] = {
        c: () => require('partner/themes/sheikhzayedfestival/sheikhzayedfestival.tsx'),
        $type: 'themeModule',
        da: [{name:'categories',  path:'actions/get-categories.action', moduleName: 'product-collection',runOn: 0},{name:'crmToken',  path:'actions/get-crm-token.action', moduleName: 'subscribe',runOn: 0},{name:'paymentStatusState',  path:'actions/get-fatoorah-payment-state.action', moduleName: 'checkout',runOn: 0}],
        definitionExtensions: ['buybox','cart-icon','cart','checkout-section-container','checkout','header','navigation-menu','order-confirmation','product-collection','search-result-container','subscribe'],
        iNM: false,
        ns: '__local__',
        n: 'sheikhzayedfestival',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'sheikhzayedfestival.theme.settings.json',
        md: 'src/themes/sheikhzayedfestival'
    });
        

        {
            const sanitizedActionPath = 'actions/get-categories.action';
            let dataAction = require('partner/actions/get-categories.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-crm-token.action';
            let dataAction = require('partner/actions/get-crm-token.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-fatoorah-payment-state.action';
            let dataAction = require('partner/actions/get-fatoorah-payment-state.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };